'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import MobileHeader from '@/components/headers/MobileHeader'
import MobileFooter1 from '@/components/footers/MobileFooter1'
import NewsLetter from '@/components/modals/NewsLetter'

export default function layoutNewsLetter({ show, data }) {
  const pathname = usePathname()
  const sp = useSearchParams()
  const lineId = sp.get('lineId') || ''
  const from = sp.get('from')

  const isForLine =
    pathname.includes('for_line') ||
    pathname.includes('line/auth') ||
    pathname.includes('barcode') ||
    from === 'line'

  return <>{!isForLine && <NewsLetter show={show} data={data} />}</>
}
